import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { IoLogoWhatsapp } from "react-icons/io";
import { templateDeatilsInfo } from "../../../SchemaInfo/info";
import { WhatsAppTemplateDetailsSchema } from "../../../Schemas/Whats App Template Details/whats_app_template_details";

const AddCompanyAssets = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handelSubmit = (values) => {
    setLoading(true);
    performRequest("POST", "/whatsAppTemplateSetting/create", values, {
      contentType: "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Template Details added successfully!");
          navigate(`/whatsapp-template-setting`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <IoLogoWhatsapp style={{ color: "green" }} /> Add Whats App
                  Template Settings Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Add Template Data</h2>
            </div>
            <Formik
              initialValues={templateDeatilsInfo}
              validationSchema={WhatsAppTemplateDetailsSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Template Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="templateName" type="text" />
                        {props.touched.templateName &&
                          props.errors.templateName && (
                            <p className="text-danger">
                              {props.errors.templateName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Template Label
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="templateLabel" type="text" />
                        {props.touched.templateLabel &&
                          props.errors.templateLabel && (
                            <p className="text-danger">
                              {props.errors.templateLabel}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Template Active Status
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="isActive" type="text">
                          <option value="">Select</option>
                          <option value="true">Active</option>
                          <option value="false">In Active</option>
                        </CustomSelect>
                        {props.touched.isActive && props.errors.isActive && (
                          <p className="text-danger">{props.errors.isActive}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Template Hit Condition
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="templateHitCondtion" type="text" />
                        {props.touched.templateHitCondtion &&
                          props.errors.templateHitCondtion && (
                            <p className="text-danger">
                              {props.errors.templateHitCondtion}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Template Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="description" rows={5} />
                        {props.touched.description &&
                          props.errors.description && (
                            <p className="text-danger">
                              {props.errors.description}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save Template Details" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddCompanyAssets;
